
// 异常捕获
export const ExceptionCommonUtil = function () {}
ExceptionCommonUtil.exceptionHandle = function (err) {
  // 用户未登录
  if (err.response.status === 401) {
    // window.location.href = '#/login'
  }
}



// WEBPACK FOOTER //
// ./src/utils/Exception.js